<template>
	<div class="about-con">
		<mobile-header :active-route="activeRoute" @active-up="beforeRoute"></mobile-header>
		<slot></slot>
		<mobile-footer :linkVisible="linkVisible" :applyFooterStyle="applyFooterStyle"></mobile-footer>
	</div>
</template>
<script>
    import bannerImage from '@/assets/mobile/resource/images/about/banner_we_01.png';
    export default{
        components: {
            MobileHeader: () => import('@/components/mobile/zh-cn/header'),
            MobileFooter: () => import('@/components/mobile/zh-cn/footer'),
        },
        data(){
            return {
                linkVisible: false,
                mainConStyle: {},
                applyFooterStyle: {
                    minHeight: '9.5rem',
                    background: '#363940'
                },
                bannerImage: bannerImage,
                activeRoute: {},
            };
        },
        methods: {
            beforeRoute(currentActiveRoute){
                const _this = this;
                var activeRoute = [];
                var activeRouteParams = _this.$route.params;
                const aboutRouteMap = [
                    'about-xhorse', 'about-patents',
                    'about-business', 'about-power',
                    'about-employee', 'about-respons', 'about-where'];
                if ($.type(currentActiveRoute) === 'undefined') {
                    if ($.isEmptyObject(activeRouteParams) === false) {
                        activeRoute = activeRouteParams;
                    } else {
                        activeRoute = {
                            activeLevel1: 1,
                            activeLevel2: 1
                        };
                    }
                } else {
                    activeRoute = currentActiveRoute;
                }
                _this.activeRoute = activeRoute;
                _this.$nextTick(function () {
                    const activeItem = document.getElementById(aboutRouteMap[activeRoute.activeLevel2 - 1]);
                    if ($.type(activeItem) === 'null') {
                        switch (activeRoute.activeLevel2) {
                            case '1':
                                window.scrollTo(0, 0);
                                break;
                            case '2':
                                window.scrollTo(0, 1415.5);
                                break;
                            case 3:
                                window.scrollTo(0, 1880.5);
                                break;
                            case 4:
                                window.scrollTo(0, 2345.5);
                                break;
                            case 5:
                                window.scrollTo(0, 3096.5);
                                break;
                            case 6:
                                window.scrollTo(0, 4074.5);
                                break;
                            case 7:
                                window.scrollTo(0, 4680.5);
                                break;
                        }
                        //console.log("#1[about][activeRoute.activeLevel2]", activeRoute.activeLevel2)
                    } else {
                        var scrollAttr = activeItem.getBoundingClientRect();
                        window.scrollTo(0, activeRoute.activeLevel2 === 1 ? 0 : scrollAttr.top);
                        //console.log("#0[about][scrollAttr]", scrollAttr, activeRoute.activeLevel2)
                    }
                });
            }
        },
        watch: {
            $route: {
                handler: 'beforeRoute',
                deep: true
            }
        },
        created(){

        },
        mounted(){
            const _this = this;
            _this.beforeRoute();
            _this.$nextTick(() => {
                document.body.style.overflow = 'auto';
            });
        }
    }
</script>

<style scoped="">


</style>


// WEBPACK FOOTER //
// src/components/page-components-mobile/index.vue